import React from 'react';

interface FeralIconProps {
  className?: string;
  strokeWidth?: number;
  style?: React.CSSProperties;
}

export const FeralIcon: React.FC<FeralIconProps> = ({ 
  className = "w-6 h-6", 
  strokeWidth = 2.5,
  style
}) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    style={style}
  >
    {/* 
      Alchemical Air Symbol: Upward triangle with horizontal line.
      Widened slightly (~8%) as requested.
      Standard triangle base would be ~86% of height. 
      We'll make the base wider relative to height.
    */}
    <path 
      d="M50 5 L95 95 H5 L50 5Z" 
      stroke="currentColor" 
      strokeWidth={strokeWidth} 
      strokeLinejoin="round" 
      strokeLinecap="round"
    />
    <path 
      d="M22 38 H78" 
      stroke="currentColor" 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
  </svg>
);
